import { LCDocumentEditorUtils } from './LCDocumentEditorUtils';
import { CKEditorLectio, ILectioPlugin } from './Types';

function accumulateElementsWithoutId(ckeditorElements: CKEDITOR.dom.nodeList, existingIds: string[]) {
	const rv: CKEDITOR.dom.element[] = [];
	for (let i = 0; i < ckeditorElements.count(); i++) {
		const el = ckeditorElements.getItem(i);
		if (!(el instanceof CKEDITOR.dom.element))
			throw new Error('ikke element');

		const existingId = el.getAttribute('id');
		if (!existingId) {
			rv.push(el);
			continue;
		} else {
			const exists = $.inArray(existingId, existingIds);
			if (exists === -1) {
				existingIds.push(existingId);
			} else {
				//Hvis et ID allerede findes så genererer vi et nyt
				rv.push(el);
			}
		}
	}

	return rv;
}

function ensureLectioIdsImpl(editor: CKEditorLectio): boolean {
	const elements = editor.editable()!.find('h1, h2, h3');
	const config = LCDocumentEditorUtils.GetEditorConfig(editor);
	const existingIds: string[] = config.forbiddedSectionPointerIds == null
		? []
		: config.forbiddedSectionPointerIds.slice(); //clone array;
	const elementsWithoutId = accumulateElementsWithoutId(elements, existingIds);

	function getRandomId(): string {
		const range = 10000000000;
		let newId = Math.floor(Math.random() * range);
		// Vil gerne have lige mange cifre i dem, blot for at vaere konsekvent.
		if (newId < range / 10)
			newId += range / 10;
		return newId.toString();
	}

	if (elementsWithoutId.length === 0)
		return false;

	// editor.fire('saveSnapshot');
	for (const el of elementsWithoutId) {
		const newId = getRandomId();
		el.setAttribute('id', newId);
	}
	// editor.fire('saveSnapshot');

	return true;
}

export function ensureLectioIds(editor: CKEditorLectio): boolean {
	return ensureLectioIdsImpl(editor);
}


function exec(editor: CKEDITOR.editor) {
	const configRootElement = LCDocumentEditorUtils.GetEditorConfig(editor).rootElement;
	if (!configRootElement)
		return true;

	const editDoc = editor.editable()!;
	const startElement = editDoc.getFirst();
	if (!(startElement instanceof CKEDITOR.dom.element))
		throw new Error('start element is not element.');

	let newEle: CKEDITOR.dom.element | null = null;
	if (!startElement) {
		newEle = getNewElement();
		editDoc.append(newEle);
	} else {
		let found = false;
		if (configRootElement === 'h1') {
			found = startElement.is('h1') || startElement.is('h2') || startElement.is('h3');
		}
		else if (configRootElement === 'h2') {
			found = startElement.is('h2') || startElement.is('h3');
		}
		else if (configRootElement === 'h3') {
			found = startElement.is('h3');
		}
		else {
			throw new Error("Ukendt rootElement!");
		}

		if (!found) {
			newEle = getNewElement();
			newEle.insertBefore(startElement);
		}
	}

	return true;

	function getNewElement(): CKEDITOR.dom.element {
		newEle = new CKEDITOR.dom.element(configRootElement);
		newEle.setText("Overskrift");
		return newEle;
	}
}

function InstallSomeMoreButtons(editor: CKEDITOR.editor) {
	// Hører ikke til i dette plugin, står her blot i mangel af bedre sted.
	if (!editor.ui.addButton)
		return;
	const buttonsToSuppress = LCDocumentEditorUtils.buttonsToSuppress;
	if (buttonsToSuppress.maximize) {
		// I inline-editor findes den ikke??
		editor.ui.addButton('lectioMaximize', {
			label: buttonsToSuppress.maximize.label!,
			command: 'maximize',
			toolbar: 'clipboard,3',
			icon: CKEDITOR.skin.icons.fullscreen!.path
		});
	}
	editor.ui.addButton('lectioUndo', {
		label: buttonsToSuppress.undo!.label!,
		command: 'undo',
		icon: 'undo',
		toolbar: ''
	});
	editor.ui.addButton('lectioRedo', {
		label: buttonsToSuppress.redo!.label!,
		command: 'redo',
		icon: 'redo',
		toolbar: ''
	});
}

export class PluginEnsureId implements ILectioPlugin {
	public Init(): void {
		CKEDITOR.plugins.add('lectioids', {
			init: editor => {
				let isUndoing = 0;
				editor.on('beforeCommandExec', (evt) => {
					if (evt.data.name !== 'undo')
						return;
					isUndoing++;
					if (isUndoing !== 1)
						console.error('isUndoing !== 1', isUndoing);
				});
				editor.on('afterCommandExec', (evt) => {
					if (evt.data.name !== 'undo')
						return;
					isUndoing--;
					if (isUndoing !== 0)
						console.error('isUndoing !== 0', isUndoing);
				});

				let isActive = false;
				editor.on('change', () => {
					if (isUndoing)
						return;
					if (isActive)
						return;
					isActive = true;
					try {
						ensureLectioIdsImpl(editor);
						exec(editor);
					} finally {
						isActive = false;
					}
				});

				const cfg = LCDocumentEditorUtils.GetEditorConfig(editor);

				InstallSomeMoreButtons(editor);
			}
		});
	}
}
